import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, CardTitle, Input } from "reactstrap";
import { useTranslation } from "react-i18next";
import { ErrorToaster, successToaster } from "components/common/toast";
import { GetChannelsAPI, GetOrderSettingsAPI, SaveChannelsAPI, SaveOrderSettingsAPI } from "network/orders";
import { errText } from "views/bookings/Agenda";

const OrderMenu = () => {
  const { t } = useTranslation("orders");
  const [mode, setMode] = useState(null);
  const [dishes, setDishes] = useState([]);
  const [dirty, setDirty] = useState({});

  const load = async () => {
    try {
      const s = await GetOrderSettingsAPI();
      setMode(s.menu_mode);
      setDishes(await GetChannelsAPI());
      setDirty({});
    } catch (e) {
      ErrorToaster(errText(e));
    }
  };
  useEffect(() => {
    load();
  }, []);

  const change = (id, patch) => {
    setDishes(dishes.map((d) => (d.id === id ? { ...d, ...patch } : d)));
    setDirty({ ...dirty, [id]: { ...(dirty[id] || {}), ...patch } });
  };
  const setModeSaved = async (m) => {
    try {
      await SaveOrderSettingsAPI({ menu_mode: m });
      setMode(m);
    } catch (e) {
      ErrorToaster(errText(e));
    }
  };
  const save = async () => {
    try {
      const rows = Object.entries(dirty).map(([id, p]) => ({ id, ...p }));
      if (!rows.length) return;
      await SaveChannelsAPI(rows);
      successToaster(t("menu.saved"));
      load();
    } catch (e) {
      ErrorToaster(errText(e));
    }
  };
  if (mode === null) return null;
  const custom = mode === "custom";
  const groups = dishes.reduce((acc, d) => {
    (acc[d.category || t("menu.other")] = acc[d.category || t("menu.other")] || []).push(d);
    return acc;
  }, {});

  return (
    <>
      <Card>
        <CardBody>
          <CardTitle tag="h4">{t("menu.question")}</CardTitle>
          <label className="d-block">
            <input type="radio" checked={!custom} onChange={() => setModeSaved("same")} />{" "}
            <strong>{t("menu.sameBold")}</strong>{t("menu.sameRest")}
          </label>
          <label className="d-block">
            <input type="radio" checked={custom} onChange={() => setModeSaved("custom")} />{" "}
            <strong>{t("menu.customBold")}</strong>{t("menu.customRest")}
          </label>
        </CardBody>
      </Card>

      {custom && (
        <Card>
          <CardBody>
            <CardTitle tag="h4">{t("menu.dishes")}</CardTitle>
            {dishes.length === 0 && <p className="text-muted">{t("menu.noDishes")}</p>}
            {Object.entries(groups).map(([cat, list]) => (
              <div key={cat} className="mb-4">
                <h5>{cat}</h5>
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr><th>{t("menu.colDish")}</th><th>{t("menu.colTablePrice")}</th><th>{t("menu.colTable")}</th><th>{t("menu.colTakeaway")}</th><th>{t("menu.colTakeawayPrice")}</th><th>{t("menu.colSoldOut")}</th></tr>
                    </thead>
                    <tbody>
                      {list.map((d) => (
                        <tr key={d.id}>
                          <td>{d.name}</td>
                          <td>{d.price} €</td>
                          <td><input type="checkbox" checked={d.available_table} onChange={(e) => change(d.id, { available_table: e.target.checked })} /></td>
                          <td><input type="checkbox" checked={d.available_takeaway} onChange={(e) => change(d.id, { available_takeaway: e.target.checked })} /></td>
                          <td style={{ maxWidth: 120 }}>
                            <Input type="number" step="0.5" min="0" placeholder={String(d.price)} disabled={!d.available_takeaway}
                              value={d.takeaway_price ?? ""} onChange={(e) => change(d.id, { takeaway_price: e.target.value })} />
                          </td>
                          <td><input type="checkbox" checked={d.sold_out} onChange={(e) => change(d.id, { sold_out: e.target.checked })} /></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
            <Button color="primary" disabled={!Object.keys(dirty).length} onClick={save}>{t("save")}</Button>
            <span className="text-muted small ml-3">{t("menu.emptyPriceHint")}</span>
          </CardBody>
        </Card>
      )}
      {!custom && dishes.length > 0 && (
        <Card><CardBody>
          <CardTitle tag="h4">{t("menu.soldOutToday")}</CardTitle>
          <p className="text-muted small">{t("menu.soldOutHelp")}</p>
          {dishes.map((d) => (
            <label key={d.id} className="mr-4 d-inline-block">
              <input type="checkbox" checked={d.sold_out} onChange={(e) => change(d.id, { sold_out: e.target.checked })} /> {d.name}
            </label>
          ))}
          <div className="mt-3"><Button color="primary" disabled={!Object.keys(dirty).length} onClick={save}>{t("save")}</Button></div>
        </CardBody></Card>
      )}
    </>
  );
};

export default OrderMenu;
